import React, { useCallback } from "react";
import { GlobalBox } from 'components/Box/GlobalBox'
import { useSelector, useDispatch } from "react-redux";
import { useSearch } from "hooks/useSearch";
import AssessmentIcon from '@mui/icons-material/Assessment';
import { TableInputs } from "components/CardTable/TableInputs"
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportSalesFilters, getReportSalesAction } from "redux/actions/Reports/reportSales/reportSalesActions";

export const ReportSalesView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(({ reportSales }) => reportSales);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault()
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return
    dispatch(getReportSalesAction({ startDate, endDate, station, isPdf }))
  }, [startDate, endDate, station]);

  return (
    <GlobalBox title="Reporte de venta del día por Zona" icon={<AssessmentIcon />} >
      {isLoadingComp?.loadingReportSales ? <LoadingComponent /> :
        <TableInputs
          reducer="reportSales"
          dates
          stations
          maxDate={newDate()}
          dispatchAction={setReportSalesFilters}
          submitAction={handleSubmit}
          submitButtonName="PDF"
          submitSecond={(e) => handleSubmit(e, false)}
        />
      }
    </GlobalBox>
  );
};
